/*@ngInject*/
const LogRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.log = function (log, level) {
        let url = '/rest/Log' + (level ? '?level=' + level : ''),
            data = [log];

        return this.post(url, data);
    };
};

angular.module('umCore')
    .service('logRepository', LogRepository);
